'use client'
import React, { useEffect, useState } from 'react'
import Script from 'next/script'
import { Context } from '@/types/app'
import { AdAllianceLib } from './AdAlliance.lib'

type AdAllianceProps = { context: Context }

async function loadBottom(BOTTOM: string) {
  if ((window as any).__ADA_BOTTOM_LOADED__) return

  if (document.getElementById('molten-bottom')) return
  const s = document.createElement('script')
  s.id = 'molten-bottom'
  s.src = BOTTOM
  s.async = true
  s.crossOrigin = 'anonymous'
  s.onload = () => {
    ;(window as any).__ADA_BOTTOM_LOADED__ = true
    console.log('[AdA] molten-bottom loaded')
  }
  s.onerror = (e) => {
    ;(window as any).__ADA_BOTTOM_LOADED__ = false
    console.error('[AdA] molten-bottom load error', e)
  }
  document.body.appendChild(s)
}

export const AdAlliance: React.FC<AdAllianceProps> = ({ context }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [topScript, setTopScript] = useState<string | undefined>()
  const [bottomScript, setBottomScript] = useState<string | undefined>()

  useEffect(() => {
    const isPreview = context.adMode === 'preview'
    setTopScript(
      isPreview
        ? 'https://adctrl.emsmobile.de/molten/preview/wetter.de/MoltenBundle.top.js'
        : '/mbundle/top.js',
    )
    setBottomScript(
      isPreview
        ? 'https://adctrl.emsmobile.de/molten/preview/wetter.de/MoltenBundle.bottom.js'
        : '/mbundle/bottom.js',
    )
    setPageLoaded(true)
  }, [])

  useEffect(() => {
    AdAllianceLib.initialize(context)
  }, [context])

  return (
    topScript &&
    bottomScript &&
    pageLoaded && (
      <Script
        id="molten-top"
        src={topScript}
        strategy="afterInteractive"
        crossOrigin="anonymous"
        onLoad={() => {
          console.log('[AdA] molten-top loaded')
          void loadBottom(bottomScript)
        }}
        onError={(e) => console.error('[AdA] molten-top load error', e)}
      />
    )
  )
}
